angular.module('picmonic-common').directive('tileTime', function () {
  return {
    restrict: 'E',
    replace: true,
    template:
      '<span class="tile-time" ng-show="visible">\n' +
      '    <span ng-show="separator">| </span><i class="material-icons md-8">access_time</i> {{time}}\n' +
      '</span>',
    scope: {
      audioLength: '<',
      separator: '<',
    },
    controller: [
      '$scope',
      function ($scope) {
        $scope.intAudioLength = parseInt($scope.audioLength, 10);

        if (!$scope.audioLength || !$scope.intAudioLength) {
          $scope.time = 0;
        } else if (parseInt($scope.audioLength, 10) < 60) {
          secs = Math.round(parseInt($scope.audioLength, 10), 2);
          $scope.time = secs + ' sec' + (secs > 1 ? 's' : '');
        } else if (parseInt($scope.audioLength, 10) < 3600) {
          mins = Math.round(parseInt($scope.audioLength, 10) / 60);
          $scope.time = mins + ' min' + (mins > 1 ? 's' : '');
        } else {
          hours = Math.floor(parseInt($scope.audioLength, 10) / 3600);
          mins = Math.round((parseInt($scope.audioLength, 10) / 60) % 60);
          $scope.time = hours + ' hr' + (hours > 1 ? 's' : '') + ' ' + mins + ' min' + (mins > 1 ? 's' : '');
        }

        $scope.visible = !!$scope.time;
      },
    ],
  };
});
